<template>
  <transition name="modal">
    <div id="container-floating" v-if="$router.history.current.name != 'livechat'">
      <div class="z-helper" style="position: relative">
        <transition name="fade">
          <div class="z-message" v-if="showModal">
            <button type="button" class="close" @click="onClose">
              <span aria-hidden="true">&times;</span>
            </button>
            <p>{{ $t('Z is here to help you :)') }}</p>
            <div>
              <template v-if="selectedBot.status">
                <a :href="'https://m.me/' + selectedBot.pageid + '?ref=menu'" target="blank">{{
                  $t('test this bot')
                }}</a>
                |
              </template>
              <template v-else>
                <a href="javascript:void(0)" @click="toggleBotStatus">{{ $t('start your bot') }}</a>
                |
              </template>
              <a
                href="https://blog.zwiz.ai/getstarted-zwizai/"
                target="_blank"
                rel="noopener noreferrer"
                >{{ $t('help') }}</a
              >
              |
              <a
                href="https://forms.gle/EXNdy4KrUGhbpjEa6"
                target="_blank"
                rel="noopener noreferrer"
                >Feedback</a
              >
            </div>
          </div>
        </transition>
        <div
          class="floating-btn"
          @click="showModal = true"
          v-intro="'The content of tooltip'"
        ></div>
      </div>
    </div>
  </transition>
</template>

<script>
import carousel from 'vue-owl-carousel'
import { mapGetters, mapMutations } from 'vuex'
import api from '@/api'

export default {
  components: { carousel },
  data: function() {
    return {
      showFinish: false,
      showModal: false
    }
  },
  computed: {
    ...mapGetters({
      showModalWelcome: 'showModalWelcome',
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    })
  },
  mounted: function() {
    var vm = this
    vm.showModal = vm.showModalWelcome
    document.addEventListener('keydown', e => {
      if (e.keyCode == 27) {
        vm.showModal = false
      }
    })
  },
  methods: {
    changed: function(event) {
      this.showFinish = event.item.index == event.item.count - 1
    },
    updated: function() {},
    onClose: function() {
      this.showModal = false
      this.$store.dispatch('clearModalWelcome')
    },
    toggleBotStatus: function() {
      let vm = this
      let bot = Object.assign({}, vm.selectedBot)
      bot.status = !bot.status

      let in_status_label = bot.status ? 'stop' : 'start'
      vm.$store.dispatch('loading')
      api.toggleBotStatus(bot, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }

        let newbotlist = vm.botlist
        $.each(newbotlist, function(index, oldbot) {
          if (bot.pageid == oldbot.pageid) {
            newbotlist[index].status = bot.status
            return false
          }
        })
        // console.log(bot)
        vm.botStatus = bot.status
        vm.$store.dispatch('selectBot', bot)
        vm.$store.dispatch('updateBotlist', newbotlist)
        vm.$store.dispatch('loading')
      })
    }
  },
  watch: {
    showModal: function() {}
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/ModalWelcome.vue